import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconLogo = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={className}
            fill='none'
            viewBox='0 0 1059 95'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M0 95H19.2114V0H0V95Z'
                fill={fill}/>
            <path
                d='M550.592 0V24.8174C550.592 38.8272 550.735 54.0379 551.162 70.8497C546.039 61.9101 538.923 50.9691 533.231 42.2963L504.912 0H483.566V95H502.066V70.1826C502.066 56.1727 502.066 40.9621 501.496 24.1503C506.62 33.3567 513.166 43.2303 519.569 52.7037L547.746 95H569.092V0H550.592Z'
                fill={fill}/>
            <path
                d='M1058.12 0H1034.22L986.828 44.8315V0H967.616V95H986.828V65.2458L1002.77 50.7022L1035.21 95H1058.12L1016.43 38.6938L1058.12 0Z'
                fill={fill}/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconLogo;
